<div class="divider-custom divider-light">
  <div class="divider-custom-line"></div>
  <div class="divider-custom-icon"><i class="fas fa-star"></i></div>
  <div class="divider-custom-line"></div>
</div>
